"use strict";

require("./_shopify-policy");